import { Card } from 'components/Card';
import { CardRow } from 'components/CardRow';
import { ICONS } from 'components/Icon';
import { ModalScreens } from 'components/Navigation/types';
import { useSelector } from 'hooks/useSelector';
import { theme } from 'lib/theme';
import React from 'react';
import { useDispatch } from 'react-redux';
import { NAVIGATE_MODAL } from 'store/actions';
import { selectBillingItemIds } from 'store/remote/selectors';
import { BillingItemCard } from './BillingItemCard';

type Props = {};

export const BillingItemCards: React.FC<Props> = () => {
  const dispatch = useDispatch();

  const billingItemIds = useSelector(selectBillingItemIds) || [];

  return (
    <>
      <Card label="Items" margin={false} />
      {!!billingItemIds.length && (
        <Card marginBottomQuarter>
          {billingItemIds.map((itemId) => (
            <BillingItemCard key={itemId} itemId={itemId} />
          ))}
        </Card>
      )}
      <Card>
        <CardRow
          label="Add item..."
          labelColor={theme.colors.blue}
          icon={ICONS.PlusLight}
          iconColor={theme.colors.blue}
          onPress={() =>
            dispatch(
              NAVIGATE_MODAL({
                screen: ModalScreens.SettingsBillingItem,
                params: { itemId: null },
              }),
            )
          }
        />
      </Card>
    </>
  );
};
